import CustomToast from "@/lib/custom-toast";
import { useAuth } from "common/hooks";
import { resetAnalytics, registerSuperProperties } from "common/analytics";
import { useDarkMode } from "@/hooks/useDarkMode";
import { resolveDeviceFormFactor } from "@/analytics/device";
import { toast } from "react-toastify";

export function useCustomToast() {
  const { logout } = useAuth();
  const isDark = useDarkMode();
  const showToast = (
    message: string,
    type: "error" | "success" | "normal" | "warning",
    options?: { title?: string; description?: string },
  ) => {
    if (message === "Failed to refresh token. Please perform the login!") {
      // Identity hygiene: token refresh failed → session expired. Clear Mixpanel identity + super
      // properties before logout so subsequent (logged-out) events aren't misattributed to the
      // expired user, then restore the device-level baseline (reset() also wipes product_type/
      // device/dark_mode). No account_logged_out — this is an automatic session-expiry logout,
      // not a user action.
      resetAnalytics();
      registerSuperProperties({
        product_type: "app",
        device: resolveDeviceFormFactor(),
        dark_mode: !!isDark,
      });
      //logout
      logout();
    }

    toast(
      <CustomToast
        message={message}
        title={options?.title}
        description={options?.description}
        onClose={() => toast.dismiss()}
        type={type}
      />,
      {
        //className:"toast-body", // Custom class to override padding
        //bodyClassName:"toast-body", // Custom class to override body margin
        progressClassName: "no-progress", // Custom class to remove progress bar
        hideProgressBar: true, // Hide the progress bar
        closeOnClick: false,
        closeButton: false,
        style: {
          padding: "0px",
          margin: "0px",
          border: 2,
          borderTopColor: "red",
          borderRadius: 12,
        },
      },
    );
  };
  return showToast;
}
